// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as ReservedActions } from '../duck';
import Reserved from '../components/Reserved';
import { push } from 'react-router-redux';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    order: state.order.order,
    itemLoadingMap: state.order.sale.reserved.itemLoadingMap,
    itemErrorMap: state.order.sale.reserved.itemErrorMap,
    isProgressing: state.order.sale.reserved.isProgressing,
    progressError: state.order.sale.reserved.progressError,
    isCanceling: state.order.sale.reserved.isCanceling,
    cancelError: state.order.sale.reserved.cancelError,
    motives: state.report.motives,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ 
    ...ReservedActions,
    goToRedirect: (route) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Reserved);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/reserved/containers/ReservedContainer.jsx